import React, {createContext, Fragment, useContext, useEffect, useRef, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Popover, Switch, Divider, Collapse
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    InfoCircleOutlined,
    CaretRightOutlined
} from '@ant-design/icons';

import ApiService from "../../services/ApiService"
import {MiddleSelect} from "antd/es/pagination/Select";
import IntlMessage from "../util-components/IntlMessage";
import TextArea from "antd/es/input/TextArea";
import {useSelector} from "react-redux";
import ImageUploadField from "./ImageUpload";


const {Search} = Input;
const {Text,Title} = Typography;
const {Option} = Select;

const OptionsCollapseContext=createContext({activeIndex:undefined});

export default function OptionsCollapse(props) {

    const [activeIndex, setActiveIndex] = useState(undefined)

    let index=0
    let children=React.Children.map(props.children, (child) => {

        if (React.isValidElement(child) && child.type===OptionsCollapseItem)
        {
            //console.log(index,child)
            let finalChild=React.cloneElement(child, {...child.props,index:index});
            index++
            return finalChild
        }

        return child
    })



    return (
        <OptionsCollapseContext.Provider value={{activeIndex:activeIndex}}>
            <Collapse
                accordion
                bordered
                ghost
                onChange={(key,)=>{
                    setActiveIndex(key?.replace(".",""))
                }}
                expandIcon={()=><span/>}
                expandIconPosition={"end"}
                style={{fontSize:18,color:"grey !important",marginBottom:20}}
            >
                {children}
            </Collapse>
        </OptionsCollapseContext.Provider>
    )

}

OptionsCollapse.Item=OptionsCollapseItem

function OptionsCollapseItem(props){

    const OptionsCollapseContextConsumer=useContext(OptionsCollapseContext);
    const [index, setIndex] = useState(props.index || 0)
    const isActive=index===parseInt(OptionsCollapseContextConsumer.activeIndex)

    let _props={...props}

    const color=isActive?"#0097B2":"grey"

    let header=(
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div style={{display: "flex", alignItems: "center", gap: 10}}>
                        <span style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderRadius: "100%",
                            color: color,
                            border: "1px solid " + color,
                            height: 25,
                            width: 25
                        }}>
                            {index + 1}
                        </span>

                <span style={{color: color}}>{props.title}</span>
            </div>


            <div>
                <CaretRightOutlined rotate={isActive ? 90 : 0} style={{color: color}}/>
            </div>
        </div>

    )

    return (
        <Collapse.Panel {..._props} forceRender key={index.toString()} header={header}
                        style={{border: "1px solid " + color, marginBottom: 20, borderRadius: 15}}>
            {props.children}
        </Collapse.Panel>
    )

}

